export default "__VITE_ASSET__3182d202__"